<template>
  <div>
    <v-row class="mt-n5">
      <v-col cols="5">
        <div>
          <span class="text--primary">ในปีงบประมาณ</span>
          <span class="text--primary font-weight-black">
            {{ otherData.budgetYear }}</span
          >
        </div>
      </v-col>
      <v-col cols="7" class="text-end">
        <v-chip small color="#E7EDF5" class="primary--text tdarken-2 ">
          <v-icon x-small class="mr-1 ">mdi-clock-outline</v-icon>
          {{ getdateNowThaFormat }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row class="mt-n2 mb-n5">
      <v-col cols="12">
        <span class="text--primary">รายละเอียดสิทธิ์วันลาที่ได้รับ</span>
      </v-col>
    </v-row>
    <v-row class="mt-n2" v-if="otherData.relaxLastYearDay !== 0">
      <v-col cols="6">
        <span>วันลาสะสมจากปี {{ previousBudgetYear }}</span>
      </v-col>
      <v-col cols="6" class="text-end">
        <span class="text-h6 mr-2 font-weight-black">{{
          otherData.relaxLastYearDay
        }}</span
        ><span>{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>
    <v-row class="mt-n2" v-if="isLeaveRelax">
      <v-col cols="6"> <span>วันลาต่อปี</span> </v-col>
      <v-col cols="6" class="text-end">
        <span class="text-h6 mr-2 font-weight-black">{{ yearRelexcheck }}</span
        ><span>{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>
    <v-row class="mt-n2" v-else>
      <v-col cols="6"> <span>วันลาต่อปี</span> </v-col>
      <v-col cols="6" class="text-end">
        <span class="text-h6 mr-2 black--text font-weight-black">{{
          otherData.currentYearLimitDay
        }}</span
        ><span>{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>
    <v-row class="mt-n2" v-if="isLeaveRelax">
      <v-col cols="6"> <span>รวม</span> </v-col>
      <v-col cols="6" class="text-end">
        <span
          class="text-h6 mr-2 font-weight-black black--text text--darken-2"
          >{{ form.LimitDay }}</span
        ><span>{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>
    <v-divider class="mb-2"></v-divider>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-row v-bind="attrs" v-on="on">
          <v-col cols="6"> <span>วันลาคงเหลือ</span> </v-col>
          <v-col cols="6" class="text-end">
            <span
              class="text-h6 mr-2 primary--text text--darken-2 font-weight-black  "
              >{{
                leaveCalLimitDayQuota >= 0 ? leaveCalLimitDayQuota : 0
              }}</span
            ><span>{{ otherData.leaveDayName }}</span>
          </v-col>
        </v-row>
      </template>
      <span
        >ในปีงบประมาณ {{ otherData.budgetYear }}
        <span v-if="form.StatLeaveLastDay > 0"
          >ใช้ไปแล้ว {{ form.StatLeaveLastDay }}
          {{ otherData.leaveDayName }}</span
        >
        <span v-else> ไม่ได้เคยลา </span>
      </span>
    </v-tooltip>

    <v-row class="mt-n3">
      <v-col cols="12">
        <span>ต้องการลา</span>
        <span class=" text--primary font-weight-black">
          {{
            form.LeaveBeginDayStatusID === 'ALL'
              ? 'เต็มวัน'
              : form.LeaveBeginDayStatusID === 'AM'
              ? 'ครึ่งเช้า'
              : 'ครึ่งบ่าย'
          }}</span
        >

        <span
          v-if="
            !(form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay) &&
              form.LeaveFinishDayStatusID !== form.LeaveBeginDayStatusID
          "
        >
          กับอีก
          <span class=" text--primary font-weight-black">{{
            form.LeaveFinishDayStatusID === 'ALL'
              ? 'เต็มวัน'
              : form.LeaveFinishDayStatusID === 'AM'
              ? 'ครึ่งเช้า'
              : 'ครึ่งบ่าย'
          }}</span>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-n5">
      <v-col cols="8">
        <span> วันที่ </span>
        <span class=" text--primary font-weight-black">
          {{ beginDateText }}</span
        >
        <span
          v-if="!(form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay)"
          class=" text--primary font-weight-black"
        >
          - {{ finishDateText }}
        </span>
        <span
          v-if="!(form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay)"
        >
          ( รวม {{ form.LeaveAmountDayAll }} วัน )</span
        >
      </v-col>
      <v-col cols="4" class="text-end">
        <span
          class="text-h5 mr-2  "
          :class="
            form.LeaveAmountDay > 0
              ? 'primary--text text--darken-2 font-weight-black'
              : 'error--text '
          "
          >{{ form.LeaveAmountDay }}</span
        ><span>{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>

    <div v-show="!otherData">{{ otherData }}</div>
    <v-row class="mt-n6 mb-n4" v-if="otherData.overLimitDay > 0">
      <v-col cols="6">
        <span class="error--text">จำนวนวันลาเกินสิทธิ์</span>
      </v-col>
      <v-col cols="6" class="text-end">
        <span class="text-h6 mr-2 font-weight-black error--text ">{{
          otherData.overLimitDay
        }}</span
        ><span class="error--text">{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>
    <v-row class="mt-n6 mb-n4" v-else>
      <v-col cols="7"> <span>หากลาครั้งนี้จะเหลือวันลา</span> </v-col>
      <v-col cols="5" class="text-end">
        <span class="text-h6 mr-2 font-weight-black warning--text ">{{
          leaveBalanceQuota >= 0 ? leaveBalanceQuota : 0
        }}</span
        ><span>{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    otherData: {
      type: Object,
      default: () => {}
    },
    form: {
      type: Object,
      default: () => {}
    },
    getdateNowThaFormat: {
      type: String,
      default: ''
    },
    isLeaveRelax: {
      type: Boolean,
      default: false
    },
    yearRelexcheck: {
      type: String,
      default: ''
    },
    leaveCalLimitDayQuota: {
      type: String,
      default: ''
    },
    beginDateText: {
      type: String,
      default: ''
    },
    finishDateText: {
      type: String,
      default: ''
    },
    leaveBalanceQuota: {
      type: String,
      default: ''
    }
  },
  computed: {
    previousBudgetYear() {
      const budgetYear = Number(this.otherData.budgetYear)
      return Number.isNaN(budgetYear)
        ? this.otherData.budgetYear
        : budgetYear - 1
    }
  }
}
</script>
<style lang=""></style>
